"use client";

import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useUserUsage } from "@/hooks/useUserUsage";
import { SHOW_REFERRAL_BANNER } from "@/lib/feature-flags";
import { ReferralModal } from "@/components/referral-modal";

const BANNER_HEIGHT = "32px";

export function ReferralBanner() {
  const { user } = useAuth();
  const { data: usageData } = useUserUsage();
  const [dismissed, setDismissed] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setDismissed(sessionStorage.getItem("referral_banner_dismissed") === "true");
  }, []);

  // Set CSS variable on :root so fixed-position sidebar can offset itself
  useEffect(() => {
    const isPaying = !!usageData && usageData.subscription?.tier !== 'free';
    const show = !!user && isPaying && SHOW_REFERRAL_BANNER && !dismissed;
    document.documentElement.style.setProperty(
      "--referral-banner-h",
      show ? BANNER_HEIGHT : "0px"
    );
    return () => {
      document.documentElement.style.setProperty("--referral-banner-h", "0px");
    };
  }, [user, usageData, dismissed]);

  const isPaying = !!usageData && usageData.subscription?.tier !== 'free';
  if (!user || !isPaying || !SHOW_REFERRAL_BANNER || dismissed) return null;

  return (
    <>
      <div className="w-full bg-white px-4 py-1.5 flex items-center justify-center gap-2 border-b border-neutral-200 shrink-0 relative">
        <span className="text-xs sm:text-sm text-neutral-800">
          Give friends <span className="font-semibold">20% off</span> — earn up to{" "}
          <span className="font-bold text-black">$80 USD cash</span> per referral.
        </span>
        <button
          onClick={() => setShowModal(true)}
          className="text-xs sm:text-sm font-semibold text-black underline underline-offset-2 decoration-neutral-400 hover:decoration-black transition-colors"
        >
          Get Code Now
        </button>
        <button
          onClick={() => {
            sessionStorage.setItem("referral_banner_dismissed", "true");
            setDismissed(true);
          }}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-0.5 hover:bg-neutral-100 rounded transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-3 w-3 text-neutral-500" />
        </button>
      </div>
      <ReferralModal open={showModal} onOpenChange={setShowModal} />
    </>
  );
}
